import { render } from "./NoticeShow.vue?vue&type=template&id=06c1cbf8&scoped=true"
import script from "./NoticeShow.vue?vue&type=script&lang=js"
export * from "./NoticeShow.vue?vue&type=script&lang=js"

import "./NoticeShow.vue?vue&type=style&index=0&id=06c1cbf8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c1cbf8"]])

export default __exports__